var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lock_svg__cls-4{fill:none;stroke:#1a2e3b;stroke-miterlimit:10;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#e8eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.89 16h.21a4.89 4.89 0 014.9 4.89v8.91h0-10 0v-8.91A4.89 4.89 0 0129.89 16z",
    strokeLinecap: "round",
    stroke: "#1a2e3b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    stroke: "#1a2e3b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    fill: "#e8eaeb",
    d: "M22 25h16v13H22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lock_svg__cls-4",
    d: "M15.11 31.4h-4.63M17.29 27.27L14.02 24M17.29 35.73L14.02 39M44.89 31.4h4.63M42.71 27.27L45.98 24M42.71 35.73L45.98 39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 30a2 2 0 10-2.89 1.78L28 34h4l-1.11-2.22A2 2 0 0032 30z",
    fill: "#1a2e3b"
  })))));
}
export default SvgLock;